import { CustomApiResponse } from '../../../../../utils/apiResponse';
import axiosInstance from '../../../../../utils/axios';
import { tokenStorage } from '../../../../../utils/tokenStorage';
import { TokenResponse } from './models';

/**
 * Login a user by sending the accessToken and type to the backend.
 * POST {{host}}/api/users/login
 */
export const loginWithGoogle = async (
  accessToken: string,
): Promise<CustomApiResponse<TokenResponse>> => {
  try {
    const payload = { accessToken, type: 'guser' };

    const response = await axiosInstance.post<CustomApiResponse<TokenResponse>>(
      '/users/login',
      payload,
      {
        headers: {
          Authorization: '',
        },
      },
    );

    return response.data;
  } catch (error: any) {
    // Check if 2FA is required (401 with methods array)
    if (error?.response?.status === 401 && error?.response?.data?.methods) {
      const twoFactorError: any = new Error('TWO_FACTOR_REQUIRED');
      twoFactorError.methods = error.response.data.methods;
      twoFactorError.email = error.response.data.email;
      twoFactorError.twoFactorRequired = true;
      twoFactorError.googleAccessToken = accessToken;
      throw twoFactorError;
    }
    throw error;
  }
};

/**
 * Login a user by sending the temporaryRfxToken and type to the backend.
 * POST {{host}}/api/users/login
 *
 * @param temporaryRfxToken - Short-lived token proving ownership of an RFX account
 * @param emailOnRmf - The RMF email to link/login to (null for account creation)
 * @param createRmfAccount - If true, creates a new RMF account from RFX profile data
 */
export const loginWithRfx = async (
  temporaryRfxToken: string,
  emailOnRmf?: string | null,
  createRmfAccount?: boolean,
): Promise<CustomApiResponse<any>> => {
  try {
    const existingJwt = tokenStorage.getAccessToken();

    const payload = {
      temporaryRfxToken,
      emailOnRmf: emailOnRmf ?? null,
      createRmfAccount: createRmfAccount ?? false,
      existingJwt,
      type: 'rfxuser',
    };

    const response = await axiosInstance.post<CustomApiResponse<any>>(
      '/users/login',
      payload,
      {
        headers: {
          Authorization: '',
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};
